// libs
import React from 'react';

import { Stack } from '@lyearn/ui';
import CarouselMediaList from '@/components/Media/components/MediaList/CarouselMediaList';

import { useEditorDetails } from '../../../context';
import { AttachmentContainerProps } from '../../types';
import { carouselClassName } from './styles';

function AttachmentContainer({
  className = 'w-auto mt-8 mb-12',
  disabled,
}: AttachmentContainerProps) {
  const { mediaContainerProps } = useEditorDetails();

  if (!mediaContainerProps || !mediaContainerProps.medias.length) {
    return null;
  }
  const { medias, onRemoveMedia } = mediaContainerProps;

  return (
    <Stack className={className}>
      <CarouselMediaList
        className={carouselClassName}
        medias={medias}
        onRemove={disabled ? undefined : onRemoveMedia}
      />
    </Stack>
  );
}

export default AttachmentContainer;
